import { Skeleton } from '@/shared/components/feedback/Skeleton';
import { EmptyState } from '@/shared/components/feedback/EmptyState';
import { ErrorState } from '@/shared/components/feedback/ErrorState';
import { PermissionDenied } from '@/shared/components/feedback/PermissionDenied';

export function WidgetLoading() {
  return (
    <div className="flex h-full w-full flex-col gap-4 p-4">
      <Skeleton className="h-6 w-1/3" />
      <Skeleton className="h-full w-full" />
    </div>
  );
}

export function WidgetEmpty({ message = 'No data available' }: { message?: string }) {
  return <EmptyState message={message} />;
}

export function WidgetError({ message = 'Failed to load widget', onRetry }: { message?: string; onRetry?: () => void }) {
  return <ErrorState message={message} onRetry={onRetry} />;
}

export { PermissionDenied as WidgetPermissionDenied };
